<template>
  <div>
      <div class="layout">
          <Layout>
              <Content>
                  <div class="container">
                      <Row type="flex" justify="end" class="chi_title">
                          <Select v-model="lang_text" class="chi_sel" @on-change="changeLanguage()" size="large">
                              <Option v-for="(item, index) in languageList" :value="item" :key="index">{{ item }}</Option>
                          </Select>
                      </Row>
                      <Row type="flex" justify="start" class="logo">
                          <img src="../assets/image/freecool.svg" alt=""/>
                      </Row>
                      <Row>
                          <p class="product_title">
                              {{$t('message.home_pro_title')}}
                          </p>
                          <p class="verify_title">{{$t('message.home_verify_title')}}</p>
                      </Row>
                      <Row class="row_file">
                          <Button type="primary" icon="ios-qr-scanner" class="button_scan" @click="showModal=true"
                                  long :loading="loading">
                              {{$t('message.home_button_scan')}}
                          </Button>
                          <Upload :show-upload-list="false" :before-upload="handleUpload" ref="upload"
                                  :data="postData"
                                  :on-format-error="handleFormatError" :action="img_upload"
                                  :on-exceeded-size="handleMaxSize" :format="['jpg','jpeg','png']" :max-size="10240"
                                  :on-success="handleSuccess" :on-error="handleError">
                              <Button icon="md-image" class="button_file" long :loading="loading">
                                  {{$t('message.home_button_file')}}
                              </Button>
                          </Upload>
                      </Row>
                  </div>
                  <div class="split-line"></div>
                  <div class="container">
                      <p class="qr_text">{{$t('message.home_qr_text')}}</p>
                      <p class="find_title">{{$t('message.home_find_title')}}</p>
                      <Row type="flex" justify="start" class="fake_img">
                          <img src="../assets/image/fake_img.png"/>
                      </Row>
                  </div>
                  <div class="img-margin">
                      <img src="../assets/image/footer.png"/>
                  </div>
                  <div class="verify_title margin">
                      Copyright © 2019 Shenzhen Oshi Biotechnology Co., Ltd. All Rights Reserved.
                  </div>
              </Content>
          </Layout>
      </div>
      <Modal v-model="showModal" class-name="info-modal" :closable="false">
          <div class="text-center">
              <img src="../assets/image/safe_icon.png"/>
              <p>{{$t('message.home_modal_hint')}}</p>
          </div>
          <div slot="footer">
              <Button type="primary" size="large" long @click="handleCamera()" class="btn_ok">
                  {{$t('message.home_modal_OK')}}
              </Button>
          </div>
      </Modal>
  </div>
</template>

<script>
  import Fingerprint2 from "fingerprintjs2";
  
  export default {
      name: "Home",
      data() {
          return {
              id: '',
              showModal: false,
              lang_text: 'English',
              languageList: ['English', '简体中文'],
              postData: {
                  access_key: ACCESS_KEY,
                  device: '',
                  type: K_TYPE
              },
              loading: true,
              img_upload: K_UPLOAD + 'anti/fake/info/qrcode'
          }
      },
      methods: {
          getId: function () {
              //获取唯一id
              Fingerprint2.get(components => {
                  let murmur = Fingerprint2.x64hash128(
                      components
                          .map(function (pair) {
                              return pair.value;
                          })
                          .join(),
                      "115109111107"
                  );
                  this.id = murmur;
              });
          },
          handleCamera() {
              this.showModal = false;
              // this.$refs.QRcodeRef.show(); //显示
              this.$router.push({name: 'Scan', params: {type: 'A'}});
          },
          handleFormatError(file) {
              this.$Notice.warning({
                  title: 'The file format is incorrect',
                  desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
              });
          },
          handleMaxSize(file) {
              this.$Notice.warning({
                  title: 'Exceeding file size limit',
                  desc: 'File  ' + file.name + ' is too large, no more than 2M.'
              });
          },
          changeLanguage() {
              this.common.language = !this.common.language;
              if (this.common.language) this.$i18n.locale = 'cn';
              else this.$i18n.locale = 'en'
          },
          handleSuccess(res) {
              let _me = this;
              _me.common.toggleLoader(false);
              let text = _me.common.language ? res.message.split('|')[0] : res.message.split('|')[1];
              if (res.code == '852003' || res.code == '852007') {
                  //产品不是正品
                  _me.$router.push({name: 'A_fake', params: {text: text}});
              } else if (res.code == '852006') {
                  //产品未激活
                  res.data.device = _me.id;
                  _me.$router.push({name: 'A_nonactivate', params: {data: res.data}});
              } else if (res.code == '852005' || res.code == '852008') {
                  //产品已激活
                  _me.$router.push({name: 'A_activate', params: {data: res.data}});
              } else if (res.code == '852004') {
                  //产品无记录
                  _me.$router.push({name: 'A_nonrecord', params: {text: text}});
              } else {
                  // _me.$Modal.info({
                  //     title: text,
                  // });
                  text = text == undefined ? res.message : text;
                  _me.$router.push({name: 'A_error', params: {text: text}})
              }
          },
          handleError(err) {
              this.common.toggleLoader(false);
              this.$Notice.warning({
                  title: err,
              });
          },
          handleUpload(file) {
              let _me = this;
              _me.common.toggleLoader(true);
              //图片压缩
              new _me.common.Compressor(file, {
                  quality: 0.4,
                  success(result) {
                      _me.$refs.upload.post(result);
                  },
                  error(error) {
                      _me.common.toggleLoader(false);
                      _me.$Notice.warning({
                          title: error,
                      });
                  }
              });
              return false;
          }
      },
      mounted() {
          this.getId();
      },
      watch: {
          id: function (val, oldVal) {
              this.loading = false;
              this.postData.device = val;
          }
      }
  }
</script>

<style scoped>
  .layout p {
      text-align: left;
  }
  
  .text-center {
      text-align: center
  }
  
  .layout img {
      object-fit: contain;
  }
  
  .logo {
      /*width: 1.9rem;*/
      height: 0.5rem;
      margin-bottom: 0.24rem;
  }
  
  .logo img {
      /*width: 100%;*/
      height: 100%;
  }
  
  .product_title {
      font-size: 0.42rem;
      color: #000000;
  }
  
  .verify_title {
      font-size: 0.26rem;
      color: #999999;
  }
  
  .button_scan {
      font-size: 0.36rem;
      margin-bottom: 0.5rem;
  }
  
  .button_file {
      font-size: 0.36rem;
      color: #ff5500;
  }
  
  .row_file {
      margin-top: 0.68rem;
  }
  
  .container {
      margin: 0 0.5rem;
      padding: 0;
  }
  
  .qr_text {
      font-size: 0.34rem;
      color: #000000;
      margin-top: 0.5rem;
  }
  
  .find_title {
      font-size: 0.26rem;
      color: #777777;
      text-align: left;
  }
  
  .fake_img {
      margin: 0.2rem 0 0.3rem;
  }
  
  .fake_title {
      font-size: 1rem;
      color: #999999;
      margin-top: 2rem;
  }
  
  .fake_title span {
      color: #ff5500;
  }
  
  .margin {
      margin: 0.36rem 0 0.34rem;
  }
  
  .chi_title {
      /*margin-bottom: 0.1rem;*/
      align-items: center;
  }
  
  .chi_title img {
      width: 0.22rem;
      height: 0.22rem;
  }
  
  .chi_sel {
      width: 100px;
  }
  
  .img-margin {
      margin-top: 0.3rem;
  }
  
  .img-margin img {
      width: 100%;
  }
  
  .info-modal {
      display: flex;
      align-items: center;
      justify-content: center;
  }
  
  .info-modal p {
      font-size: 0.26rem;
      color: #000000;
      margin-top: 0.64rem;
  }
  
  .info-modal img {
      width: 2.2rem;
  }
  
  .btn_ok {
      font-size:0.36rem;
  }
</style>
